import { Button } from '@mui/material';
import React from 'react'
import useMediaQuery from '@mui/material/useMediaQuery';
import Typewriter from 'typewriter-effect';

const Home = (props) => {
    const mediaMatch = useMediaQuery('(min-width:680px)');
    return (
        <div style={{display:mediaMatch?"flex":"block", gap:'10px', padding:'5%',marginTop:"17%", height: mediaMatch ? '50vh':'80vh'}}>
            <div style={{
                width:'35vw',
                // backgroundColor:'#1976d2'
            }}>
                <img src='new-profile-pic.png' className='img-scale' height='300px' width='250px' alt="profile" style={{
                    borderRadius:'10%',
                }}/>
            </div>
            <div style={{
                display:'grid',
                justifyContent:'center',
                alignContent:'center',
                width:'65vw',
                fontFamily: "Comic Sans MS, Arial, Helvetica, San-serif"
                // backgroundColor:'#1976d2',
                // color:'white'
            }}>
                <div style={{
                    width:'55vw'
                }}>
                    <Typewriter
                        options={{
                            loop: true,
                            }}
                        onInit={(typewriter) => {
                            typewriter.typeString('<h1>Hi, I am Sharang Ahirekar</h1>')
                            .typeString('<h2>Full stack Web Developer</h2>')
                            .pauseFor(8500)
                            .start();
                            
                        }}
                    />
                </div>
                <div style={{
                    marginTop:30
                }}>
                    <div style={{display:'flex',gap:20}}>
                        <div><Button variant='contained' ><a style={{textDecoration:'none',color:'white'}} href={"https://drive.google.com/file/d/1AfMKlXXOzhSg5WWDZbUs4m1MA3p7uuse/view?usp=sharing"} target='_blank' rel='noreferrer'>View Resume</a></Button></div>
                        <div><Button variant='outlined'><a style={{textDecoration:'none',color:'#1976d2'}} href="./Sharang-A-Resume.pdf" download="Sharang-Ahirekar-Resume">Download</a></Button></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Home;